import { AuthApi } from './modules/auth.api';
import { SmartwatchApi } from './modules/smartwatch.api';
import { ClientApi } from './modules/client.api';
import { WalkApi } from "@/api/modules/walk.api";
import { LocationApi } from "@/api/modules/location.api";
import { NotificationApi } from "@/api/modules/notification.api";
import { EmployeeApi } from "@/api/modules/employee.api";
import { EnvironmentConfigurationApi } from "@/api/modules/environment.config.api";

import msalInstance from './services/msal.service';
import axios from 'axios';

export interface IHttpClient {
  get<T = any>(url: string): Promise<{ data: T }>;
  delete<T = any>(url: string): Promise<{ data: T }>;
  post<T = any>(url: string, data?: any): Promise<{ data: T }>;
  put<T = any>(url: string, data?: any): Promise<{ data: T }>;
  patch<T = any>(url: string, data?: any): Promise<{ data: T }>;
}

// Use stubs/fixtures when e2e or unit testing
// const isStub = process.env.VUE_APP_TEST === 'e2e';
export const Api = {
  Auth: AuthApi(msalInstance),
  Smartwatch: SmartwatchApi(axios),
  Client: ClientApi(axios),
  Walk: WalkApi(axios),
  Location: LocationApi(axios),
  Notification: NotificationApi(axios),
  Employee: EmployeeApi(axios),
  EnvironmentConfig: EnvironmentConfigurationApi(axios)
};

// Sets the default headers according to the key and value.
export const setDefaultHeader = (key: string, value: string) => {
  axios.defaults.headers.common[key] = value;
};
